export const fuseConfig = {
    keys: ['_name', '_phone', '_uhid'],
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
    shouldSort: false,
};

export const patientFuseLimit = 101;
export const GLOBAL_SEARCH_APPT = "GLOBAL_SEARCH_APPT";
